module.exports = __webpack_public_path__ + "img/educacao2.3380571b.svg";